import React from 'react'
import data_flow from "../../assets/images/brands/data_flow.png"
import sales_force from "../../assets/images/brands/salesforce.png"
import spark_loft from "../../assets/images/brands/sparkloft.png"
import vcqr from "../../assets/images/brands/VCQR.png"
import ashoka from "../../assets/images/brands/ashoka.png"
import Slider from 'react-slick';
import prev_arrow from "../../assets/images/icons/prev-arrow_24px.svg"
import next_arrow from "../../assets/images/icons/next-arrow_24px.svg"
import { useMediaQuery } from '@mui/material'
import theme from './../../assets/themes/theme';
import { useTranslation } from 'react-i18next'

const HomeCarousel = () => {
    const { t } = useTranslation()

    const carouselData = [
        {
            id: 1,
            image: data_flow,
            content: t('home-page.home-carousel.data.content-1'),
            author: "Garry Taylor",
            company: t('home-page.home-carousel.data.position-company-1')
        },
        {
            id: 2,
            image: ashoka,
            content: t('home-page.home-carousel.data.content-2'),
            author: "Anu Batra",
            company: t('home-page.home-carousel.data.position-company-2')
        },
        {
            id: 3,
            image: spark_loft,
            content: t('home-page.home-carousel.data.content-3'),
            author: "Elena Ferranto",
            company: t('home-page.home-carousel.data.position-company-3')
        },
        {
            id: 4,
            image: vcqr,
            content: t('home-page.home-carousel.data.content-4'),
            author: "Alfredo A. García",
            company: t('home-page.home-carousel.data.position-company-4')
        },
        {
            id: 5,
            image: sales_force,
            content: t('home-page.home-carousel.data.content-5'),
            author: "Sandra",
            company: t('home-page.home-carousel.data.position-company-5')
        },
    ]

    function NextArrow(props) {
        const { onClick, classes } = props;
        return (
            <div
                className={classes}
                onClick={onClick}
            >
                <img src={next_arrow} alt="" />
            </div>
        );
    }

    function PrevArrow(props) {
        const { onClick, classes } = props;
        return (
            <div
                className={classes}
                onClick={onClick}
            >
                <img src={prev_arrow} alt="" />
            </div>
        );
    }

    const isMatch = useMediaQuery(theme.breakpoints.down("lg"));

    const settings = {
        centerMode: true,
        infinite: true,
        centerPadding: isMatch ? "100px" : "300px",
        slidesToShow: 1,
        speed: 500,
        nextArrow: <NextArrow classes={"next-carousel-button"} />,
        prevArrow: <PrevArrow classes={"prev-carousel-button"} />
    };


    return (

        <div className='carousel'>

            <Slider {...settings} >
                {carouselData.map((d) => (
                    <div className='carousel-item' key={d.id}>
                        <div className='max-w-1340 flex flex-column justify-evenly'>
                            <div>
                                <img src={d.image} alt="" className='client-s-140' />
                            </div>
                            <div>
                                <p className='content-italic'>{d.content}</p>
                            </div>
                            <div>
                                <p className='font-weight-semi-bold'>{d.author}</p>
                                <p>{d.company}</p>
                            </div>
                        </div>
                    </div>

                ))}
            </Slider>
        </div>


    )
}

export default HomeCarousel